import { createContext } from 'react';

const AdaptiveCardHostConfigContext = createContext();

export default AdaptiveCardHostConfigContext;
